import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helpersNumbers from "../../../../../helpers/numbers";
import validationsFormsAddGift from "../../../../../validtions/forms/gift/add";

export default function AddGift() {
  const history = useHistory();
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const sendForm = async () => {
    const dataForm = getDataForm();
    const resultValidationsFormsAddGift = validationsFormsAddGift(dataForm);
    if (resultValidationsFormsAddGift != true) {
      setMessage({
        type_class: "alert alert-danger ",
        text: resultValidationsFormsAddGift,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddGift = await sendRequestAddGift(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddGift) {
      return;
    }
    history.push(`/finance/manage/all-gift`);
  };

  const getDataForm = () => {
    return {
      min_amount: minAmount,
      max_amount: maxAmount,
      percent: document.querySelector("#percent").value,
    };
  };

  const [minAmount, setMinAmount] = useState(1000000);
  const [maxAmount, setMaxAmount] = useState(5000000);

  const inputMinAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setMinAmount(parseInt(number));
  };
  const inputMaxAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setMaxAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const sendRequestAddGift = async (dataForm) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/gift/manage",
        dataForm,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger ",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return true;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">اضافه کردن هدیه</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link to="/finance/manage/all-gift" className="btn btn-primary">
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  sendForm();
                }}
              >
                <div className="py-2">
                  <div className="pb-2">حداقل مبلغ</div>
                  <div>
                    <div class="input-group">
                      <input
                        onWheel={(event) => event.currentTarget.blur()}
                        type="text"
                        class="form-control number-finance"
                        value={helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(minAmount)
                        )}
                        onChange={inputMinAmountChangeHandler}
                        onBeforeInput={inputAmountBeforeInputHandler}
                        dir="ltr"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">تومان</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="py-2">
                  <div className="pb-2">حداکثر مبلغ</div>
                  <div>
                    <div class="input-group">
                      <input
                        onWheel={(event) => event.currentTarget.blur()}
                        type="text"
                        class="form-control number-finance"
                        value={helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(maxAmount)
                        )}
                        onChange={inputMaxAmountChangeHandler}
                        onBeforeInput={inputAmountBeforeInputHandler}
                        dir="ltr"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">تومان</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex py-2">
                  <span className="pl-2">
                    <label>درصد : </label>
                  </span>
                  <span>
                    <input
                      style={{ width: "50px" }}
                      tabIndex="1"
                      onWheel={(event) => event.currentTarget.blur()}
                      dir="rtl"
                      type="number"
                      id="percent"
                      max="99"
                      min="1"
                      className="form-control"
                      required
                    />
                  </span>
                </div>
                <div>
                  <button className="btn btn-success">اضافه کردن</button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
